import { type FilterItem } from 'widgets/FilterEditor/model'

export const IntegrationKeys = new Set(['workflows.integration_id'])

export const isIntegrationWidget = (filterItem: FilterItem) => IntegrationKeys.has(filterItem.key)
